export const DIGITAL_ASSETS_PORTFOLIO_ROUTE = '/digital-assets';
export const DIGITAL_ASSETS_CRYPTO_CREATE_WALLET_ROUTE =
  '/crypto/create-wallet';
export const DIGITAL_ASSETS_CREATE_WALLET_INITIAL =
  '/digital-assets/create-wallet';
export const DIGITAL_ASSETS_CREATE_WALLET_MFA =
  '/digital-assets/create-wallet/enable-mfa';
export const DIGITAL_ASSETS_CREATE_WALLET_PASSKEYS =
  '/digital-assets/passkeys/create-wallet';
export const DIGITAL_ASSETS_IMPORT_WALLET_PASSKEYS =
  '/digital-assets/passkeys/import-wallet';

/** Path prefixes of the screens where a customer creates or imports a wallet. */
export const WALLET_CREATION_ROUTES = [
  DIGITAL_ASSETS_CRYPTO_CREATE_WALLET_ROUTE,
  DIGITAL_ASSETS_CREATE_WALLET_INITIAL,
  DIGITAL_ASSETS_CREATE_WALLET_MFA,
  DIGITAL_ASSETS_CREATE_WALLET_PASSKEYS,
  DIGITAL_ASSETS_IMPORT_WALLET_PASSKEYS,
] as const;
